/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportType } from './ImportType';
import {
    ImportTypeFromJSON,
    ImportTypeFromJSONTyped,
    ImportTypeToJSON,
    ImportTypeToJSONTyped,
} from './ImportType';
import type { ImportMapping } from './ImportMapping';
import {
    ImportMappingFromJSON,
    ImportMappingFromJSONTyped,
    ImportMappingToJSON,
    ImportMappingToJSONTyped,
} from './ImportMapping';

/**
 * 
 * @export
 * @interface CreateMappingProfileRequest
 */
export interface CreateMappingProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMappingProfileRequest
     */
    name?: string | null;
    /**
     * 
     * @type {ImportType}
     * @memberof CreateMappingProfileRequest
     */
    importType?: ImportType;
    /**
     * 
     * @type {ImportMapping}
     * @memberof CreateMappingProfileRequest
     */
    mapping?: ImportMapping;
}



/**
 * Check if a given object implements the CreateMappingProfileRequest interface.
 */
export function instanceOfCreateMappingProfileRequest(value: object): value is CreateMappingProfileRequest {
    return true;
}

export function CreateMappingProfileRequestFromJSON(json: any): CreateMappingProfileRequest {
    return CreateMappingProfileRequestFromJSONTyped(json, false);
}

export function CreateMappingProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMappingProfileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'importType': json['importType'] == null ? undefined : ImportTypeFromJSON(json['importType']),
        'mapping': json['mapping'] == null ? undefined : ImportMappingFromJSON(json['mapping']),
    };
}

export function CreateMappingProfileRequestToJSON(json: any): CreateMappingProfileRequest {
    return CreateMappingProfileRequestToJSONTyped(json, false);
}

export function CreateMappingProfileRequestToJSONTyped(value?: CreateMappingProfileRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'importType': ImportTypeToJSON(value['importType']),
        'mapping': ImportMappingToJSON(value['mapping']),
    };
}

